import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faLungs, faBed } from '@fortawesome/free-solid-svg-icons';

function DataDisplayRowTextSessionType(props) {
    const { label, value, helpText, type="text"} = props;
    return (
        <div class="field pb-4">
            <label class="label">{label}</label>
            <div class="control">
                <p>
                    {value
                        ?
                        <>
                        {value === "base" &&
                            <>
                                <FontAwesomeIcon className="mdi" icon={faInfoCircle} />&nbsp;Base
                            </>
                        }
                        {value === "breath" &&
                            <>
                                <FontAwesomeIcon className="mdi" icon={faLungs} />&nbsp;Breathwork
                            </>
                        }
                        {value === "sleep" &&
                            <>
                                <FontAwesomeIcon className="mdi" icon={faBed} />&nbsp;Sleep
                            </>
                        }
                        </>
                        :
                        "-"
                    }
                </p>
                {helpText !== undefined && helpText !== null && helpText !== "" && <p class="help">{helpText}</p>}
            </div>
        </div>
    );
}

export default DataDisplayRowTextSessionType;
